export default {
    request_time_to_center_data(lat,lon,top_speed){
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        "source": {
          "lat": lat,
          "lon": lon
        },
        "top_speed":top_speed
      });
    
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
      };
      return fetch("/geocoder/time_to_center", requestOptions).then(response => response.json());
    },
    request_source_to_list(sources,destinations,top_speed){
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        "sources": sources,
        "destinations": destinations,
        "top_speed":top_speed
      });
    
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
      };
      return fetch("/geocoder/source_to_list", requestOptions).then(response => response.json());
    },
    request_route_locations(locations,top_speed){
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        "locations": locations,
        "top_speed":top_speed
      });
    
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
      };
      return fetch("/geocoder/route_locations", requestOptions).then(response => response.json());
    },
    request_op_route_locations(locations,top_speed){
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        "locations": locations,
        "top_speed":top_speed
      });
    
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
      };
      return fetch("/geocoder/op_route_locations", requestOptions).then(response => response.json());
    },
  };